// module.exports = {

// 	standard_sliders: null,
// 	standard_sliders_array: [],
// 	standard_slider_init: function( re_init ) {
// 		// I will add propper code for these components here later...
// 	}


// }
import Flickity from 'flickity'

function init() {
    let postGrids = document.querySelectorAll('.postGrid')

    for (var i = 0; i < postGrids.length; i++) {
        let flkty = new Flickity( postGrids[i], {
            watchCSS: true,
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
        })
    }
}
  
export default {
    init,
}

  


